import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, ArrowUpRight, Layers } from "lucide-react";
import { useWaitlist } from "../context/WaitlistContext";

export default function Navbar() {
  const { openWaitlist } = useWaitlist();
  const { pathname } = useLocation();
  const home = pathname === "/";
  const [productsOpen, setProductsOpen] = useState(false);

  return (
    <header
      className="border-b border-white/5 bg-ink/80 backdrop-blur-xl"
      data-testid="navbar"
    >
      <div className="container-x flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <img
            src="/brand/smritium-mark-white.png"
            alt=""
            className="h-8 w-8 object-contain"
          />
          <span className="font-display text-2xl lowercase leading-none text-paper">
            smritium
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          <div
            className="relative"
            onMouseEnter={() => setProductsOpen(true)}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <button
              onClick={() => setProductsOpen((v) => !v)}
              className="flex items-center gap-1 text-sm text-mute transition-colors hover:text-paper"
              data-testid="nav-products"
            >
              Products
              <ChevronDown
                size={14}
                className={`transition-transform duration-200 ${
                  productsOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <AnimatePresence>
              {productsOpen && (
                <motion.div
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 8 }}
                  transition={{ duration: 0.18 }}
                  className="absolute left-0 top-full z-50 pt-3"
                >
                  <div className="w-72 rounded-xl border border-white/10 bg-void/95 p-2 shadow-2xl backdrop-blur-xl">
                    <p className="px-3 pb-1 pt-2 font-mono text-[10px] uppercase tracking-overline text-mute">
                      Built on Smritium
                    </p>
                    <a
                      href="https://semalayer.com"
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-start gap-3 rounded-lg px-3 py-3 transition-colors hover:bg-white/5"
                      data-testid="nav-products-semalayer"
                    >
                      <span className="mt-0.5 flex h-8 w-8 items-center justify-center rounded-lg bg-ember/15 text-ember">
                        <Layers size={16} />
                      </span>
                      <span>
                        <span className="flex items-center gap-1 font-display text-paper">
                          Sema Layer <ArrowUpRight size={13} className="text-mute" />
                        </span>
                        <span className="mt-0.5 block text-xs leading-relaxed text-mute">
                          A semantic layer built on the Smritium memory substrate.
                        </span>
                      </span>
                    </a>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          <a
            href={home ? "#substrate" : "/#substrate"}
            className="text-sm text-mute transition-colors hover:text-paper"
            data-testid="nav-substrate"
          >
            The Substrate
          </a>
          <a
            href={home ? "#vision" : "/#vision"}
            className="text-sm text-mute transition-colors hover:text-paper"
            data-testid="nav-vision"
          >
            Sovereignty
          </a>
          <a
            href={home ? "#roadmap" : "/#roadmap"}
            className="text-sm text-mute transition-colors hover:text-paper"
            data-testid="nav-roadmap"
          >
            Roadmap
          </a>
          <Link
            to="/about"
            className="text-sm text-mute transition-colors hover:text-paper"
            data-testid="nav-about"
          >
            About
          </Link>
        </nav>

        <button
          onClick={() => openWaitlist()}
          className="btn-primary !px-5 !py-2.5 text-[13px]"
          data-testid="nav-waitlist-button"
        >
          Join Waitlist
        </button>
      </div>
    </header>
  );
}
